// All of the requested modules are loaded behind enumerable getters.
const map = Object.defineProperties({}, {
  "./(tabs)/_layout.tsx": { enumerable: true, get() { return require("/Users/aodebu/Documents/Develop/gakumonlens-app/app/(tabs)/_layout.tsx"); } },
  "./(tabs)/create.tsx": { enumerable: true, get() { return require("/Users/aodebu/Documents/Develop/gakumonlens-app/app/(tabs)/create.tsx"); } },
  "./(tabs)/index.tsx": { enumerable: true, get() { return require("/Users/aodebu/Documents/Develop/gakumonlens-app/app/(tabs)/index.tsx"); } },
  "./(tabs)/library.tsx": { enumerable: true, get() { return require("/Users/aodebu/Documents/Develop/gakumonlens-app/app/(tabs)/library.tsx"); } },
  "./(tabs)/mylens.tsx": { enumerable: true, get() { return require("/Users/aodebu/Documents/Develop/gakumonlens-app/app/(tabs)/mylens.tsx"); } },
  "./(tabs)/profile.tsx": { enumerable: true, get() { return require("/Users/aodebu/Documents/Develop/gakumonlens-app/app/(tabs)/profile.tsx"); } },
  "./(tabs)/teacher.tsx": { enumerable: true, get() { return require("/Users/aodebu/Documents/Develop/gakumonlens-app/app/(tabs)/teacher.tsx"); } },
  "./+not-found.tsx": { enumerable: true, get() { return require("/Users/aodebu/Documents/Develop/gakumonlens-app/app/+not-found.tsx"); } },
  "./_layout.tsx": { enumerable: true, get() { return require("/Users/aodebu/Documents/Develop/gakumonlens-app/app/_layout.tsx"); } },
  "./admin/library-cms.tsx": { enumerable: true, get() { return require("/Users/aodebu/Documents/Develop/gakumonlens-app/app/admin/library-cms.tsx"); } },
  "./auth/callback.tsx": { enumerable: true, get() { return require("/Users/aodebu/Documents/Develop/gakumonlens-app/app/auth/callback.tsx"); } },
  "./cards/[cardId].tsx": { enumerable: true, get() { return require("/Users/aodebu/Documents/Develop/gakumonlens-app/app/cards/[cardId].tsx"); } },
  "./delete-account.tsx": { enumerable: true, get() { return require("/Users/aodebu/Documents/Develop/gakumonlens-app/app/delete-account.tsx"); } },
  "./marketing.tsx": { enumerable: true, get() { return require("/Users/aodebu/Documents/Develop/gakumonlens-app/app/marketing.tsx"); } },
  "./privacy-policy.tsx": { enumerable: true, get() { return require("/Users/aodebu/Documents/Develop/gakumonlens-app/app/privacy-policy.tsx"); } },
  "./privacy.tsx": { enumerable: true, get() { return require("/Users/aodebu/Documents/Develop/gakumonlens-app/app/privacy.tsx"); } },
});

function metroContext(request) {
    return map[request];
}

// Return the keys that can be resolved.
metroContext.keys = function metroContextKeys() {
  return Object.keys(map);
};

// Return the module identifier for a user request.
metroContext.resolve = function metroContextResolve(request) {
  throw new Error('Unimplemented Metro module context functionality');
}

module.exports = metroContext;